export var translationPath = function (baseUrl, locale) { return baseUrl + "assets/locale/gallery/gallery_" + locale + ".json"; };
export var DEFAULT_COLLECTION_ID = '00000000-000000-000000-000000000001';
export var TRACK_EVENT_COLLECTION = 'All Products';
export var GALLERY_FEDOPS_APP_NAME = 'wixstores-gallery';
export var SLIDER_GALLERY_FEDOPS_APP_NAME = 'wixstores-slider-gallery';
export var sortingOptions = [
    {
        field: '',
        id: 'default',
        titleKey: 'sortTitleText',
    },
    {
        field: 'creationDate',
        direction: "DESC" /* Descending */,
        id: 'newest',
        titleKey: 'sortOptionNewestText',
        settingsShouldDisplayKey: 'gallerySortNewest',
    },
    {
        field: 'comparePrice',
        direction: "ASC" /* Ascending */,
        id: 'price_ascending',
        titleKey: 'sortOptionLowPriceText',
        settingsShouldDisplayKey: 'gallerySortPriceAsc',
    },
    {
        field: 'comparePrice',
        direction: "DESC" /* Descending */,
        id: 'price_descending',
        titleKey: 'sortOptionHighPriceText',
        settingsShouldDisplayKey: 'gallerySortPriceDes',
    },
    {
        field: 'name',
        direction: "ASC" /* Ascending */,
        id: 'name_ascending',
        titleKey: 'sortOptionNameAZText',
        settingsShouldDisplayKey: 'gallerySortNameAsc',
    },
    {
        field: 'name',
        direction: "DESC" /* Descending */,
        id: 'name_descending',
        titleKey: 'sortOptionNameZAText',
        settingsShouldDisplayKey: 'gallerySortNameDes',
    },
];
export var keyboardEvents = {
    ENTER: { keyCode: 13, charCode: 13 },
    SPACEBAR: { keyCode: 32, charCode: 32 },
    ARROW_UP: { keyCode: 38, charCode: 38 },
    ARROW_DOWN: { keyCode: 40, charCode: 40 },
    ARROW_RIGHT: { keyCode: 39, charCode: 39 },
    ARROW_LEFT: { keyCode: 37, charCode: 37 },
};
//# sourceMappingURL=constants.js.map